import { Module, VuexModule, Action } from "vuex-module-decorators";
import { firebase, functions, ROLE } from "@/api/firebase";

@Module({ namespaced: true })
export default class ToolBoxStore extends VuexModule {
  /**
   * @summary Allows Verification of emails when the emails get lost/ take too long etc
   * @param emails A list of emails to be submitted
   */
  @Action
  public async verifyEmails(
    emails: string[]
  ): Promise<firebase.functions.HttpsCallableResult> {
    const verifyEmails = functions.httpsCallable("Tool_EmailVerify");
    return await verifyEmails({ emails: emails });
  }

  /**
   * @summary Allows check account exists
   * @param emails A list of emails to be submitted
   */
  @Action
  public async checkAccountExists(
    emails: string[]
  ): Promise<firebase.functions.HttpsCallableResult> {
    const accountExists = functions.httpsCallable("Tool_AccountConfirmEmail");
    return await accountExists({ emails: emails });
  }

  /**
   * @summary Send a new password reset email
   * @param emails A list of emails to be submitted
   */
  @Action
  public async sendPasswordReset(
    emails: string[]
  ): Promise<firebase.functions.HttpsCallableResult> {
    const passwordReset = functions.httpsCallable("Tool_SendPasswordReset");
    return await passwordReset({ emails: emails });
  }

  /**
   * @summary Admin functions to send user roles
   * @param uids A list of uids to be submitted
   * @param role A role to be submitted
   */
  @Action({ rawError: true })
  public async sendUserRole(
    uids: any
  ): Promise<firebase.functions.HttpsCallableResult> {
    const setUserRole = functions.httpsCallable("Admin_SetUserRoles");
    return await setUserRole({ uids: uids.uid, role: uids.role });
  }

  /**
   * @summary Reset POI's
   * @param tgs TGS ID
   */
  @Action({ rawError: true })
  public async resetPoi(
    data: any
  ): Promise<firebase.functions.HttpsCallableResult> {
    const resetPoi = functions.httpsCallable("PoiReset");
    return await resetPoi(
      JSON.stringify({
        tgsID: data.tgs,
        g_id: data.gameKey,
        teamID: data.teamID,
      })
    );
  }

  /**
   * @summary Set Evergreen Game
   * @param templateId Game key
   */
  @Action({ rawError: true })
  public async processEverGreenGame(
    templateId: string
  ): Promise<firebase.functions.HttpsCallableResult> {
    const processEverGreenGame1 = functions.httpsCallable(
      "ProcessEvergreenGame_SINGLE"
    );
    return await processEverGreenGame1({
      templateID: templateId,
      numMonthsAhead: 1,
    });
  }

  /**
   * @summary Set Evergreen Game
   * @param templateId Game key
   */
  @Action({ rawError: true })
  public async refresh_voucher(
    gameId: string
  ): Promise<firebase.functions.HttpsCallableResult> {
    const refresh = functions.httpsCallable("Admin_CreateGame_Vouchers");
    return await refresh({
      quant: 1,
      g_id: gameId,
      isUniversal: true,
    });
  }
}
